
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um-vafrakokur",
      function () {
        return require("private-next-pages/um-vafrakokur/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um-vafrakokur"])
      });
    }
  